import { render, staticRenderFns } from "./unCreationInfo.vue?vue&type=template&id=800534b0&scoped=true"
import script from "./unCreationInfo.vue?vue&type=script&lang=js"
export * from "./unCreationInfo.vue?vue&type=script&lang=js"
import style0 from "./unCreationInfo.vue?vue&type=style&index=0&id=800534b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800534b0",
  null
  
)

export default component.exports